import React, { Fragment, useState } from "react";
import Header from "../common/Header";
import homepage_header_image from "./../assets/images/homepage_header_image.png";
import parcel_point_icon_blue from "./../assets/images/parcel_point_icon_blue.png";
import parcel_point_icon from "./../assets/images/parcel_point_icon.png";
import locker_icon from "./../assets/images/locker_icon.png";
import door_icon from "./../assets/images/door_icon.png";
import HomepageSelectedService from "./HomepageSelectedService";
import { useParams } from "react-router-dom";
import CheckIcon from '@mui/icons-material/Check';
import Footer from "../common/Footer";
import { Box, Grid } from "@mui/material"
import ParcelPointHeader from "./common/ParcelPointHeader";
import KioskHeader from "./common/KioskHeader";
import { useNavigate } from "react-router-dom"; 

const pickup_services = [
    {
        'text': 'Point',
        'value': 'pp',
        'icon': parcel_point_icon,
        'color': 'bg-[#1D2953]',
    },
    {
        'text': 'Locker',
        'value': 'locker',
        'icon': locker_icon,
        'color': 'bg-[#F2BA56]',
    },
    {
        'text': 'Kiosk',
        'value': 'kiosk',
        'icon': locker_icon,
        'color': 'bg-[#E5854A]',
    },
    {
        'text': 'Door',
        'value': 'door',
        'icon': door_icon,
        'color': 'bg-[#6EA3D5]',
    }
]

const Homepage = () => {
    let { type } = useParams();
    const navigate = useNavigate();
    
    const [selectedPickup, setSelectedPickup] = useState('');
    
    const select_services = (value) => {
        setSelectedPickup(value)
    }

    React.useEffect(() => {
        const baseUrl = `${window.location.protocol}//${window.location.host}`;
        
        if(process.env.REACT_APP_ENV === 'production'){
            if(baseUrl === 'https://qr.thecourierguy.co.za'){
                if(type === 'pp'){
                    navigate('/');
                }
            } else {
                if(type !== 'pp'){
                    navigate('/pp');
                }
            }
        }
    });

    const filtered_pickup_services = pickup_services.filter(service => 
        type === 'pp' || service.value !== 'pp'
    );
   
    
    const pickup_services_list = filtered_pickup_services.map((services, key) => {
        return (
            <Grid item key={services.value} xs={6} md={4} lg={3} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <div className={`${services.color} text-gray-800 py-6 px-10 rounded-lg flex flex-col items-center text-center w-full h-full`}>
                    <img loading="lazy" src={services.icon} alt={services.text} className="mb-2 w-20 h-16" />
                    <h4 className="text-md font-semibold text-white">{services.text}</h4>
                </div>
                <button
                    onClick={() => select_services(services.value)}
                    className={`w-full mt-2 bg-[${selectedPickup === services.value ? '#1D2953' : '#2B549A'}] text-white font-semibold px-4 py-2 rounded hover:bg-[#1D2953]`}
                >
                    {selectedPickup === services.value ? <CheckIcon fontSize="small" /> : null} Select
                </button>
            </Grid>
        );
    });
   
    return <Fragment>
        <Header type={type} />
       
        <main className="flex-1 pt-20 pb-16">
            <div className="max-w-6xl m-auto">
                <div className={`bg-[#F8F8F8] ${(type === 'pp') ? 'p-16' : 'p-14' } md:p-${(type === 'pp') ? '16' : '11' } relative`}>
                    <div className="grid gap-6 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 items-center">
                        <img src={parcel_point_icon_blue} alt="Point Icon" className="w-32 h-auto ml-32 hidden sm:block" />
                        <div className="col-span-1 sm:col-span-2 md:col-span-1 text-center sm:text-left">
                            {type === 'pp' && (<h2 className="text-2xl font-semibold text-[#2B549A]">Point </h2>)}
                            {(type === 'pp') ? <ParcelPointHeader /> :  <KioskHeader /> }
                           
                        </div>
                        <img src={homepage_header_image} alt="Delivery illustration" className={`w-72 h-auto hidden sm:block absolute top-[${type === 'pp' ? '35px' : '65px'}] right-[20px] md:right-[120px]`} />
                    </div>
                </div>
                <Box
                    sx={{ background: '#E2EDF7', px: { xs: 2, sm: 3 }, py: 7, maxWidth: 1600, mx: "auto", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center" }}
                >
                    <Grid container spacing={3} columnGap={4} alignItems="stretch" justifyContent="center">
                        <Grid item xs={8} md={4} lg={2.2} sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <h4 className="text-lg font-semibold text-[#1D2953] mb-3">Drop-off:</h4>
                            <div
                                className={`${type === 'pp' ? 'bg-[#1D2953]' : 'bg-[#E5854A]'} text-white py-6 px-10 rounded-lg flex flex-col items-center justify-center w-full`}
                            >
                                <img loading="lazy" src={type === 'pp' ? parcel_point_icon : locker_icon} alt="Point Drop-off" className="mb-2 w-20 h-16" />
                                <p className="text-sm font-bold">{type === 'pp' ? 'Point' : 'Kiosk'}</p>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={8} lg={9}  >
                            <h4 className="text-lg font-semibold text-[#1D2953] mb-3 text-center">Pick-up:</h4>
                            <Grid container spacing={2} justifyContent="center" alignItems="stretch" sx={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }} >
                                {pickup_services_list}
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>


                <HomepageSelectedService selected_dropoff={type ?? 'kiosk'} selected_pickup={selectedPickup} selected_service={pickup_services.filter(value => value.value === selectedPickup)} services={pickup_services}/>
            </div>
        </main>
        <Footer/>
    </Fragment>
}

export default Homepage;